// src/components/ui/ButtonLink.tsx
import React from "react";
import { Link, LinkProps } from "react-router-dom";

type Variant = "blue" | "orange" | "gray" | "ghost";

type ButtonLinkProps = Omit<LinkProps, "className"> & {
  className?: string;
  variant?: Variant;
};

const base =
  "inline-flex items-center justify-center rounded px-4 py-2 transition-colors";
const variants: Record<Variant, string> = {
  blue: "bg-elani-blue text-white hover:opacity-90",
  orange: "bg-elani-orange text-white hover:bg-elani-orange-dark",
  gray: "bg-gray-200 text-gray-800 hover:bg-gray-300",
  ghost: "border border-gray-300 text-gray-800 hover:bg-gray-100",
};

export default function ButtonLink({
  variant = "blue",
  className = "",
  ...rest
}: ButtonLinkProps) {
  return <Link {...rest} className={[base, variants[variant], className].join(" ").trim()} />;
}
